
window.Gift ?= {}

Gift.init = (payload, done) ->
  Gift.cookieDomain = payload?.giftButton?.cookieDomain

  $ ->
    Gift.bindGiftButton()
    done()

Gift.bindGiftButton = ->
  $gift_button  = $('.gift-button')

  if $gift_button.length > 0
    $gift_button.on('click', (e) ->
      e.preventDefault()
      Gift.createCookie()

      BuyButton.view.giftButtonClicked = true
      BuyButton.eventBus.go 'buy_button_clicked'
    )

Gift.createCookie = ->
  Cookie.set('modalForGiftOnLoad','true',60, Gift.cookieDomain)
  Gift.cookieCreated = true

Gift.removeCookie = ->
  Cookie.unset('modalForGiftOnLoad', Gift.cookieDomain)
  Gift.cookieCreated = false

module.exports = Gift



// WEBPACK FOOTER //
// ./modules/gift_button/frontend/gift.coffee